var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C2C8CE",
    d: "M28 55C13.088 55 1 42.912 1 28S13.088 1 28 1s27 12.088 27 27-12.088 27-27 27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C8CE",
    fillRule: "nonzero",
    d: "M19.424 29.01a1.415 1.415 0 0 1 0-2.02l11.734-11.571a1.463 1.463 0 0 1 2.05 0l1.368 1.35c.565.556.566 1.46.002 2.018L25.279 28l9.299 9.213a1.415 1.415 0 0 1-.002 2.019l-1.369 1.35a1.463 1.463 0 0 1-2.05 0L19.425 29.01z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.925e43118c5e1876b419c384035c3775.svg";
export { ForwardRef as ReactComponent };